/* eslint-disable array-callback-return */
import * as Constants from '../utils/constants';

const initialState = {
  loading: false,
  data: null,
  success: false,
  error: false,
  error_msg: '',
};

const GetAllUSSDReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_ALL_USSD: {
      return {
        ...state,
        loading: true,
      };
    }
    case Constants.ALL_USSD_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    }
    case Constants.ALL_USSD_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };
    }
    
    case Constants.ALL_USSD_RESET: {
      return {
        ...state,
        loading: false,
        error: false,
        error_msg: '',
        success: false,
        data: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default GetAllUSSDReducer;
